import React, { useEffect, useState } from 'react';
import BookOverview from '../../../types/BookOverviewType';
import OverviewTemplate from '../../04_templates/OverviewTemplate/OverviewTemplate';
import useAPI from '../../../hooks/useAPI';

function AdminOverviewPage() {
  const { Get } = useAPI();
  const [books, setBooks] = useState<BookOverview[]>();

  const getBooks = async () => {
    try {
      const data = await Get<BookOverview[]>(`/books`);
      setBooks(data);
    } catch (error) {
      globalThis.dispatchEvent(
        new CustomEvent('ShowAlert', {
          detail: {
            label:
              error instanceof Error
                ? error.message
                : 'Er is een fout opgetreden bij het ophalen van de boeken',
            type: 'Warning',
          },
        }),
      );
    }
  };

  useEffect(() => {
    document.title = 'Sweet Bibi - Overzicht';
    getBooks();
  }, []);

  return (
    <main>
      <OverviewTemplate data={books} />
    </main>
  );
}

export default AdminOverviewPage;

